import { render } from "./AdminInvitationsView.vue?vue&type=template&id=4d897188&scoped=true"
import script from "./AdminInvitationsView.vue?vue&type=script&lang=js"
export * from "./AdminInvitationsView.vue?vue&type=script&lang=js"

import "./AdminInvitationsView.vue?vue&type=style&index=0&id=4d897188&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d897188"]])

export default __exports__